import FirstSlick from "../Slick/FirstSlick";
import Header from "./../Header/Header";
import MainMap from "../Map/MainMap";
import Footer from "../Footer/Footer";
import YouTube from "react-youtube";
import "animate.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ReviewSlick from "../Slick/ReviewSlick";
import MobileReviewSlick from "../Slick/MobileReviewSlick";

const Home = () => {
  const navigate = useNavigate();
  const animateRef0 = useRef();
  const animateRef1 = useRef();
  const animateRef2 = useRef();
  const animateRef3 = useRef();
  const animateRef4 = useRef();
  const animateRef5 = useRef();
  const animateRef6 = useRef();
  const animateRef7 = useRef();
  const animateRef8 = useRef();
  const animateRef9 = useRef();
  const pulse1 = useRef();
  const pulse2 = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust this value based on when you want the animation to trigger
    };

    const handleIntersectionPulse = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateRef.current.classList.add(
            "animate__animated",
            "animate__pulse"
          );
          observer.unobserve(entry.target);
        }
      });
    };

    const handleIntersectionSlideInRight = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateRef.current.classList.add(
            "animate__animated",
            "animate__fadeInRight"
          );
          observer.unobserve(entry.target);
        }
      });
    };

    const handleIntersectionSlideInLeft = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateRef.current.style.animationDuration = "1.5s";
          animateRef.current.classList.add(
            "animate__animated",
            "animate__fadeInLeft"
          );
          observer.unobserve(entry.target);
        }
      });
    };
    const observer0 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef0),
      options
    );
    if (animateRef0.current) {
      animateRef0.current.style.opacity = "0";
      observer0.observe(animateRef0.current);
    }
    const observer1 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef1),
      options
    );
    if (animateRef1.current) {
      animateRef1.current.style.opacity = "0";
      observer1.observe(animateRef1.current);
    }
    const observer2 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef2),
      options
    );
    if (animateRef2.current) {
      animateRef2.current.style.opacity = "0";
      observer2.observe(animateRef2.current);
    }
    const observer3 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef3),
      options
    );
    if (animateRef3.current) {
      animateRef3.current.style.opacity = "0";
      observer3.observe(animateRef3.current);
    }
    const observer4 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef4),
      options
    );
    if (animateRef4.current) {
      animateRef4.current.style.opacity = "0";
      observer4.observe(animateRef4.current);
    }
    const observer5 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef5),
      options
    );
    if (animateRef5.current) {
      animateRef5.current.style.opacity = "0";
      observer5.observe(animateRef5.current);
    }
    const observer6 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef6),
      options
    );
    if (animateRef6.current) {
      animateRef6.current.style.opacity = "0";
      observer6.observe(animateRef6.current);
    }
    const observer7 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef7),
      options
    );
    if (animateRef7.current) {
      animateRef7.current.style.opacity = "0";
      observer7.observe(animateRef7.current);
    }
    const observer8 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef8),
      options
    );
    if (animateRef8.current) {
      animateRef8.current.style.opacity = "0";
      observer8.observe(animateRef8.current);
    }
    const observer9 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef9),
      options
    );
    if (animateRef9.current) {
      animateRef9.current.style.opacity = "0";
      observer9.observe(animateRef9.current);
    }
    const pulseObserver1 = new IntersectionObserver(
      (entries, observer) => handleIntersectionPulse(entries, observer, pulse1),
      options
    );
    if (pulse1.current) {
      pulseObserver1.observe(pulse1.current);
    }
    const pulseObserver2 = new IntersectionObserver(
      (entries, observer) => handleIntersectionPulse(entries, observer, pulse2),
      options
    );
    if (pulse2.current) {
      pulseObserver2.observe(pulse2.current);
    }
    return () => {
      observer0.disconnect();
      observer1.disconnect();
      observer2.disconnect();
      observer3.disconnect();
      observer4.disconnect();
      observer5.disconnect();
      observer6.disconnect();
      observer7.disconnect();
      observer8.disconnect();
      observer9.disconnect();
      pulseObserver1.disconnect();
      pulseObserver2.disconnect();
    };
  }, []);
  const movePage = (path) => {
    navigate(path);
    window.location.reload();
  };

  const opts = {
    height: "490",
    width: "100%",
  };
  const listopts = {
    height: "89",
    width: "190",
  };
  const mobilelistopts = {
    height: "89",
    width: "100%",
  };
  const eighthBackRef = useRef(null);
  const mobileBottom = useRef(null);
  const moveBottom = () => {
    const location = eighthBackRef.current.offsetTop;

    console.log(location);
    eighthBackRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const moveMobileBottom = () => {
    const location = mobileBottom.current.offsetTop;

    console.log(location);
    mobileBottom.current.scrollIntoView({ behavior: "smooth" });
  };

  const openMap = () => {
    window.location.href =
      "https://www.google.com/maps/place/%ED%82%A4%EC%9B%80%EC%86%8C%EC%95%84%EC%B2%AD%EC%86%8C%EB%85%84%EA%B3%BC%EC%9D%98%EC%9B%90/data=!4m6!3m5!1s0x357ca105b63df7df:0x59d4bd1fea306798!8m2!3d37.5043295!4d127.0010666!16s%2Fg%2F11f9_n67bx?entry=ttu";
  };
  const mobileopts = {
    height: "380",
    width: "100%",
  };
  const [inner, setInner] = useState(false);
  const showInner = () => {
    setInner(!inner);
  };
  return (
    <div className="wrap main_wrap">
      <div className="main_web_back">
        {/* <Aside /> */}
        <Header />
        <FirstSlick />
        <div className="icon_box">
          <div className={`inner_icon ${inner && "active"}`}>
            {/* <div className="icon gps" onClick={() => moveBottom()}></div> */}
            <div
              className="icon naver"
              onClick={() =>
                window.open(
                  "https://m.booking.naver.com/booking/13/bizes/472715#"
                )
              }
            ></div>
            <div
              className="icon youtube"
              onClick={() =>
                window.open("https://youtube.com/@Kiumtv?si=DxftFuul2W62hO8G")
              }
            ></div>
            <div
              className="icon kakao"
              onClick={() => window.open("http://pf.kakao.com/_xnRukb")}
            ></div>
            <div
              className="icon blog"
              onClick={() => window.open("https://blog.naver.com/h_kyoung")}
            ></div>
          </div>
          <div className="main_icon">
            {inner ? (
              <div className="icon xIcon" onClick={() => showInner()}></div>
            ) : (
              <div className="icon here" onClick={() => showInner()}></div>
            )}
          </div>
        </div>
        <div className="section second_section">
          <div className="second_banner_box">
            <div className="second_banner"></div>
          </div>
          <div className="doctor_banner_box">
            <div
              className="doctor_banner animate__animated"
              ref={animateRef0}
            ></div>
            <div className="second_text_box">
              <div
                className="second_text title animate__animated"
                ref={animateRef1}
              >
                소중한 임상 경험 및 전문 지식을 바탕으로 한명 한명 소중히 더
                정성스런 진료를 위해 노력하도록 하겠습니다.
              </div>
              <div className="second_text animate__animated" ref={animateRef2}>
                대학병원부터 성장클리닉 개인 의원으로 이어져 진료하는 동안 많은
                의사 선생님들과 부모님들이 자녀를 맡겨 주시는 성장 진료로
                20여년의 역사가 되어가고 있습니다.
              </div>
              <div
                className="second_text small animate__animated"
                ref={animateRef3}
              >
                *키움성장클리닉은 명확한 성장판 나이 판독을 통해, 차별화된
                최적의 솔루션을 제공합니다.
              </div>
            </div>
          </div>
        </div>

        <div className="section third_section">
          <div className="third_back">
            <div className="section_title_box">
              <div className="section_title">의료진 소개</div>
              <div
                className="title_icon"
                onClick={() => movePage("/intro")}
              ></div>
            </div>
            <div className="third_img_box">
              <div className="img_all"></div>
              <div className="third_img_row">
                <div
                  className="third_img long_first animate__animated"
                  ref={animateRef6}
                ></div>
                <div
                  className="third_img short_first animate__animated"
                  ref={animateRef7}
                ></div>
              </div>
              <div className="third_img_row">
                <div
                  className="third_img short_second animate__animated"
                  ref={animateRef8}
                ></div>
                <div
                  className="third_img long_second animate__animated"
                  ref={animateRef9}
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div className="section fourth_section">
          <div className="fourth_back">
            <div className="section_title_box">
              <div className="section_title">주요진료과목</div>
            </div>
            <div className="third_contents_box">
              <div className="third_contents" onClick={() => movePage("/grow")}>
                <div className="third_img_box">
                  <div className="third_img"></div>
                </div>
                <div className="third_text_box">
                  <div className="title_text">키성장클리닉</div>
                  <div className="sub_text">
                    골연령 및 키성장예측
                    <br />
                    성장인지혈액정밀검사
                    <br />
                    성장호르몬 주사 치료
                  </div>
                </div>
              </div>
              <div
                className="third_contents"
                onClick={() => movePage("/disease")}
              >
                <div className="third_img_box">
                  <div className="third_img second"></div>
                </div>
                <div className="third_text_box">
                  <div className="title_text">성조숙증클리닉</div>
                  <div className="sub_text">
                    사춘기발달 상태 검사 및 성조숙증 확진검사 성조숙증 주사치료
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section fifth_section">
          <div className="fifth_back">
            <div className="section_title_box">
              <div className="section_title">방송출연 자료</div>
            </div>
            <div className="fifth_content_box">
              <div className="fifth_video_back">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={opts}
                    videoId={"maWnhAYIJgc"}
                  ></YouTube>
                </div>
                <div className="video_list_box">
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"yEsbeqqA4rs"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        운동을 더많이할수록 키가 더 큰다?
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"R3OZKBVd-pE"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        키 성장을 위한 핵심 포인트
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"RqQnAvSATm0"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        먹는대로 다 키로 갈까요? 비만은 키성장을방해한다
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"SQ4aMhCojDM"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        키 성장 검사는 언제 시작하는 것이 좋은가요？
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"Gbiq_bNHnVw"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        사춘기가 빠르거나 성조숙증 시 반드시 주의해야 할 포인트
                        대한소아청소년과의사회 학술이사
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="fifth_bottom_box">
              <div
                className="bottom_text_box animate__animated"
                ref={animateRef4}
              >
                대학병원부터 서울 첫 성장클리닉 개인 의원으로 시작하여 20여년의
                역사가 되어가고 있습니다. 소중한 임상 경험 및 전문 지식을
                바탕으로 더 정성스런 진료를 위해 노력하도록 하겠습니다.
              </div>
              <div className="bottom_btn_box">
                <div
                  className="bottom_btn"
                  onClick={() =>
                    window.open(
                      "https://youtube.com/@Kiumtv?si=DxftFuul2W62hO8G"
                    )
                  }
                >
                  채널로 이동
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sixth_back">
          {/* <div className="review_box">
            <div className="web_box">
              <div className="review_row">
                <div className="review_block title">
                  <div className="review_title_box">
                    <div className="review_icon"></div>
                    <div className="reivew_title">
                      키움 고객님이
                      <br /> 남겨주신 리뷰
                    </div>
                    <div
                      className="review_btn"
                      onClick={() => movePage("/review")}
                    >
                      모두 보기 {">"}
                    </div>
                  </div>
                </div>
                <div className="review_block">
                  <div className={`review_img img_1`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">
                      키움성장클리닉 병원에서 추적관찰하고 싶은 믿음이
                      생겼습니다.
                    </div>
                    <div className="review_text bottom">
                      다른 병원 방문 후 뼈나이가 너무 높게 나와서 방문하게
                      되었습니다. 선생님께서 친절히 아이 뼈사진과 자료사진과
                      비교해봐주시면서 자세히 설명 해주셔서 아이의 상태를
                      이해하는데 많은 도움이 되었습니다. 너무 감사드리고.. 계속
                      키움성장클리닉 병원에서 추적관찰하고 싶은 믿음이
                      생겼습니다.
                    </div>
                  </div>
                </div>
                <div className="review_block">
                  <div className={`review_img`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">
                      원장선생님께서 알기쉽게 아이의 뼈나이와 성장속도를 설명해
                      주셨어요.
                    </div>
                    <div className="review_text bottom">
                      원장선생님께서 알기쉽게 아이의 뼈나이와 성장속도를 설명해
                      주셨어요. 그리고 성장을 위해 필요한 것들을
                      설명해주셨습니다. 사실 수면, 영향, 운동 다 아는 얘기지만
                      현실적으로 공부하는 나이라 다 챙기기 쉽지않은 현실인데 이
                      시기에 꼭 챙겨야할 것들을 다시한번 생각해봤네요. 자칫
                      성장클리닉은 공포감? 조성해서 걱정을 배가 시킨다고
                      들었는데, 객관적인 설명을 들을수있어서 좋았습니다.
                    </div>
                  </div>
                </div>
                <div className="review_block">
                  <div className={`review_img`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">
                      아이한테도 어떤 걸 먹으면 좋은지 얘기해 주셔서 너무
                      좋았어요
                    </div>
                    <div className="review_text bottom">
                      오늘 예약한 시간 맞춰서 다녀왔는데 검사 비용은 다른 병원과
                      차이는 나지 않았지만 설명을 상세히 해주셨고 이해가 잘
                      되도록 해주셨어요 아이가 체중이 좀 있는 편이어서
                      걱정됐었는데 이것도 잘 말씀해주셨고 아이한테도 어떤 걸
                      먹으면 좋은지 얘기해 주셔서 너무 좋았어요 앞으로 팔로우업
                      하면서 다녀볼 생각이예요!
                    </div>
                  </div>
                </div>
              </div>
              <div className="review_row">
                <div className="review_block">
                  <div className={`review_img`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">
                      절대로 공포 유발하지 않으시고 아이 진심으로
                      걱정해주십니다!
                    </div>
                    <div className="review_text bottom">
                      좋으신 선생님 항상 좋은말씀 많이 해주시고 절대로 공포
                      유발하지 않으시고 아이 진심으로 걱정해주시고 뵐때마다 참
                      감사해요 그나마 선생님 덕에 멘탈 붙들고 지냈던 거
                      같아요ㅠㅠ 3개월후에 뵙겠습니다 진심이 전해지는 진료 늘
                      감사합니다
                    </div>
                  </div>
                </div>
                <div className="review_block">
                  <div className={`review_img`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">감사합니다</div>
                    <div className="review_text bottom">
                      원장님 너무좋으시고, 아이에게도 설명 친절히 잘해주셔서
                      아이가 미션 받은 느낌으로 집에 돌아와선 밥이랑 잘
                      챙겨먹겠다고 하네요! 감사합니다
                    </div>
                  </div>
                </div>
                <div className="review_block">
                  <div className={`review_img`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">
                      말 한마디로도 큰 힘 주시는 선생님 항상 감사합니다
                    </div>
                    <div className="review_text bottom">
                      초1 입학 직전이었으니 벌써 햇수로 4년째네요...
                      자식일인지라 병원가기 전이면 늘 마음이 무겁고 신경이 많이
                      쓰이는데 원장님이 항상 말씀을 정말 예쁘게 하셔서 병원 나올
                      때면 심적으로 치유받는 느낌이에요 간호사분들도 모두
                      친절하세요 단순히 집에서 가까워서 가는 병원 아니고 근처에
                      강남성모도 있지만 자동으로 여기로 올 수 밖에 없답니다:)
                      여자 아이라 여 선생님이 더 편하기도 하지만 단순히 그런
                      이유를 넘어서 정말로 아이의 성장을 위해 고민해주시고
                      함부로 재단하지 않으시는 허 선생님이 계시기에 그래요 말
                      한마디로도 큰 힘 주시는 선생님 항상 감사합니다
                    </div>
                  </div>
                </div>
                <div className="review_block">
                  <div className={`review_img`}></div>
                  <div className="review_text_box">
                    <div className="review_text title">
                      원장님이 너무 진정성 있게 진료를 봐주시네요
                    </div>
                    <div className="review_text bottom">
                      원장님이 너무 진정성 있게 진료를 봐주시네요 저희 아이가
                      또래보다 키가 좀 커서 걱정이 많이 되어가지구 엑스레이도
                      촬영하고 초음파도 봤어요 뼈나이는 만나이와 비슷하다 하시구
                      가슴발달도 걱정할 정돈 아니라하셔서 6개월뒤에 다시
                      체크하러 오라고 하셨어요 설명도 알아듣기 쉽게 해주시고
                      아이한테도 거부감없이 대화하면서 잘 먹으라고 해주셨어요
                      다녀오니 마음이 너무 편하네요 6개월뒤에도 미리 예약하고
                      왔습니다ㅎㅎ 과잉진료도 없고 너무 잘 보고왔습니다
                      감사해요~~
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mobile_box">
              <div className="review_block title">
                <div className="review_title_box">
                  <div className="review_icon"></div>
                  <div className="reivew_title">
                    키움 고객님이
                    <br /> 남겨주신 리뷰
                  </div>
                  <div
                    className="review_btn"
                    onClick={() => movePage("/review")}
                  >
                    모두 보기 {">"}
                  </div>
                </div>
              </div>
              <div className="review_scroll_box">
                <div className="review_row">
                  {[...Array(parseInt(6))].map((data, index) => {
                    return (
                      <div className="review_block">
                        <div className={`review_img img_${index + 1}`}></div>
                        <div className="review_text_box">
                          <div className="review_text title">
                            친절한 진찰과 전문적인친절한 진찰과 전문적인
                          </div>
                          <div className="review_text bottom">
                            gula eget dolor. Aenean massa. Cum sociis toque
                            penatibus et magnis dis parturient montes, netur
                            ridiculus mus. Donec quam felis, ultricies nec,
                            pellentesque eu, pretium quis, sem. Nulla consequat
                            massa quis enim. Donec pede justo, fringilla vel,
                            aliquet nec, vu
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="review_row">
                  {[...Array(parseInt(6))].map((data, index) => {
                    return (
                      <div className="review_block">
                        <div className={`review_img img_${index + 2}`}></div>
                        <div className="review_text_box">
                          <div className="review_text title">
                            친절한 진찰과 전문적인친절한 진찰과 전문적인
                          </div>
                          <div className="review_text bottom">
                            gula eget dolor. Aenean massa. Cum sociis toque
                            penatibus et magnis dis parturient montes, netur
                            ridiculus mus. Donec quam felis, ultricies nec,
                            pellentesque eu, pretium quis, sem. Nulla consequat
                            massa quis enim. Donec pede justo, fringilla vel,
                            aliquet nec, vu
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}
          <div className="section_title_box">
            <div className="section_title">고객리뷰</div>
            <div
              className="title_icon"
              onClick={() => movePage("/review")}
            ></div>
          </div>
          <div className="review_box">
            <ReviewSlick></ReviewSlick>
          </div>
        </div>
        <div className="middle_banner_box">
          <div className="middle_banner"></div>
          <div className="mobile_banner_text_box">
            <div className="banner_title">세계로 뻗어나가는 키움성장클리닉</div>
            <div className="banner_text">
              미국/캐나다/홍콩/ 싱가폴/ 말레이시아/ 베트남/몽골/중국/
              인도/호주/스위스/ 폴란드/네덜란드 /독일 세계에서 사랑받는
              키움성장클리닉입니다.
            </div>
          </div>
        </div>
        <div className="seventh_back">
          <div className="section_title_box">
            <div className="section_title">병원 둘러보기</div>
            <div
              className="title_icon"
              onClick={() => movePage("/clinic")}
            ></div>
          </div>
          <div className="seventh_contents_box">
            <div className="seventh_img_area">
              <div className="seventh_img"></div>
            </div>
          </div>
        </div>
        <div className="eighth_back" id="eighth_back" ref={eighthBackRef}>
          <div className="section_title_box">
            <div className="section_title">찾아오시는 길</div>
          </div>
          <div className="eighth_container">
            <div className="map_box">
              <MainMap></MainMap>
            </div>
            <div className="eighth_contents_box">
              <div className="contents_title sub">키움성장의원</div>
              <div className="contents_title">
                서울특별시 서초구 반포대로 287
                <br /> 래미안퍼스티지 중심상가 3층
              </div>
              <div className="time_text_box">
                <div className="time_text">월 – 금 : 10 : 00 ~ 18 : 00</div>
                <div className="time_text">(목요일 휴진)</div>
                <div className="time_text blue">토요일 : 09 : 00 ~ 13 : 00</div>
              </div>
              <div className="tel_title">진료예약</div>
              <div className="tel_text">02-532-8575</div>
              <div className="sub_text">
                건물 3층에 위치 고속터미널역 출입구 6번 출구에서274m
                지하상가출구 1번출구(래미안퍼스티지아파트)에서 에스컬레이터로
                연결됩니다.
              </div>
              <div className="sub_text sub">지하 2,3층 주차장, 2시간무료</div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <div className="main_mobile_back">
        <Header />
        <FirstSlick />
        <div className="icon_box">
          <div className={`inner_icon ${inner && "active"}`}>
            {/* <div className="icon gps" onClick={() => moveBottom()}></div> */}
            <div
              className="icon naver"
              onClick={() =>
                window.open(
                  "https://m.booking.naver.com/booking/13/bizes/472715#"
                )
              }
            ></div>
            <div
              className="icon youtube"
              onClick={() =>
                window.open("https://youtube.com/@Kiumtv?si=DxftFuul2W62hO8G")
              }
            ></div>
            <div
              className="icon kakao"
              onClick={() => window.open("http://pf.kakao.com/_xnRukb")}
            ></div>
            <div
              className="icon blog"
              onClick={() => window.open("https://blog.naver.com/h_kyoung")}
            ></div>
          </div>
          <div className="main_icon">
            {inner ? (
              <div className="icon xIcon" onClick={() => showInner()}></div>
            ) : (
              <div className="icon here" onClick={() => showInner()}></div>
            )}
          </div>
        </div>
        <div className="m_first_area">
          <div className="slide_img_row">
            <div className="slide_img_box">
              <div className="slide_img"></div>
            </div>
            <div className="slide_img_box">
              <div className="slide_img second"></div>
            </div>
            <div className="slide_img_box">
              <div className="slide_img third"></div>
            </div>
            <div className="slide_img_box">
              <div className="slide_img fourth"></div>
            </div>
          </div>
        </div>
        <div className="m_middle_area">
          <div className="third_title_box">
            <div className="title_text">의료진 소개</div>
            <div className="title_sub">
              키움성장클리닉의 의료진을 소개합니다.
            </div>
            <div className="title_btn" onClick={() => movePage("/intro")}>
              모두 보기 {">"}
            </div>
          </div>
          {/*<div
            className="middle_banner_box"
            onClick={() => movePage("/intro")}
          ></div>*/}
        </div>

        <div className="m_img_area">
          <div className="img_row">
            <div className="img_box"></div>
            <div className="img_box second"></div>
          </div>
          <div className="img_row">
            <div className="img_box third"></div>
            <div className="img_box fourth"></div>
          </div>
        </div>
        <div className="m_second_area">
          <div className="second_box left">
            <div className="tree_img"></div>
          </div>
          <div className="second_box right">
            <div className="second_text_box">
              <div className="title_text">
                소중한 임상 경험 및 전문 지식을 바탕으로 한명 한명 소중히 더
                정성스런 진료를 위해 노력하도록 하겠습니다.
              </div>
              <div className="sub_text">
                대학병원부터 성장클리닉 개인 의원으로 이어져 진료하는 동안 많은
                의사 선생님들과 부모님들이 자녀를 맡겨 주시는 성장 진료로
                20여년의 역사가 되어가고 있습니다.
              </div>
            </div>
          </div>
          <div className="second_bottom_box">
            *키움성장클리닉은 명확한 성장판 나이 판독을 통해, 차별화된 최적의
            솔루션을 제공합니다.
          </div>
        </div>
        <div className="m_third_area">
          <div className="third_title_box">
            <div className="title_box"></div>
            <div className="title_text">주요진료과목</div>
            <div className="title_sub">
              키움성장클리닉에서의 진료 과목을 소개합니다.
            </div>
            {/* <div className="title_btn" onClick={() => movePage("/disease")}>
              모두 보기 {">"}
            </div> */}
          </div>
          <div className="third_contents_box">
            <div className="third_contents" onClick={() => movePage("/grow")}>
              <div className="third_img_box">
                <div className="third_img"></div>
              </div>
              <div className="third_text_box">
                <div className="title_text">키성장클리닉</div>
                <div className="sub_text">
                  골연령 및 키성장예측
                  <br />
                  성장인지혈액정밀검사
                  <br />
                  성장호르몬 주사 치료
                </div>
              </div>
            </div>
            <div
              className="third_contents"
              onClick={() => movePage("/disease")}
            >
              <div className="third_img_box">
                <div className="third_img second"></div>
              </div>
              <div className="third_text_box">
                <div className="title_text">성조숙증클리닉</div>
                <div className="sub_text">
                  사춘기발달 상태 검사 및 성조숙증 확진검사 성조숙증 주사치료
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="m_fourth_area">
          <div className="third_title_box">
            <div className="title_box"></div>
            <div className="title_text">방송출연 자료</div>
            <div className="title_sub">
              여러가지 정보를 얻을 수 있는 영상자료입니다.
            </div>
            <div className="title_btn" onClick={() => movePage("/commu")}>
              모두 보기 {">"}
            </div>
          </div>
          {/* <div className="video_box">
            <YouTube
              className="youtube_video"
              opts={mobileopts}
              videoId={"75xamd4Ku8A"}
            ></YouTube>
          </div> */}
          <div className="video_list_box">
            <div className="video_row">
              <div className="row_video_box">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={mobilelistopts}
                    videoId={"yEsbeqqA4rs"}
                  ></YouTube>
                </div>
              </div>
              <div className="row_text_box">
                <div className="row_title">
                  운동을 더많이할수록 키가 더 큰다?
                </div>
                <div className="row_text">키크니TV</div>
              </div>
            </div>
            <div className="video_row">
              <div className="row_video_box">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={mobilelistopts}
                    videoId={"R3OZKBVd-pE"}
                  ></YouTube>
                </div>
              </div>
              <div className="row_text_box">
                <div className="row_title">키 성장을 위한 핵심 포인트</div>
                <div className="row_text">키크니TV</div>
              </div>
            </div>
            <div className="video_row">
              <div className="row_video_box">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={mobilelistopts}
                    videoId={"RqQnAvSATm0"}
                  ></YouTube>
                </div>
              </div>
              <div className="row_text_box">
                <div className="row_title">
                  먹는대로 다 키로 갈까요? 비만은 키성장을방해한다
                </div>
                <div className="row_text">키크니TV</div>
              </div>
            </div>
            <div className="video_row">
              <div className="row_video_box">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={mobilelistopts}
                    videoId={"SQ4aMhCojDM"}
                  ></YouTube>
                </div>
              </div>
              <div className="row_text_box">
                <div className="row_title">
                  키 성장 검사는 언제 시작하는 것이 좋은가요？
                </div>
                <div className="row_text">키크니TV</div>
              </div>
            </div>
            <div className="video_row">
              <div className="row_video_box">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={mobilelistopts}
                    videoId={"Gbiq_bNHnVw"}
                    modestbranding={0}
                  ></YouTube>
                </div>
              </div>
              <div className="row_text_box">
                <div className="row_title">
                  사춘기가 빠르거나 성조숙증 시 반드시 주의해야 할 포인트
                  대한소아청소년과의사회 학술이사
                </div>
                <div className="row_text">키크니TV</div>
              </div>
            </div>
          </div>
          {/* <div className="fourth_bottom_box">
            <div className="fourth_text">
              대학병원부터 서울 첫 성장클리닉 개인 의원으로 시작하여 20여년의
              역사가 되어가고 있습니다. 소중한 임상 경험 및 전문 지식을 바탕으로
              더 정성스런 진료를 위해 노력하도록 하겠습니다.
            </div>
          </div> */}
        </div>
        <div className="m_fifth_area">
          <div className="third_title_box">
            <div className="title_box"></div>
            <div className="title_text">고객리뷰</div>
            <div className="title_sub">고객님들의 소중한 솔직 리뷰입니다.</div>
            <div className="title_btn" onClick={() => movePage("/review")}>
              모두 보기 {">"}
            </div>
          </div>
          {/* <div className="review_scroll_box">
            <div className="review_row">
              <div className="review_block">
                <div className={`review_img img_1`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    키움성장클리닉 병원에서 추적관찰하고 싶은 믿음이 생겼습니다.
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    원장선생님께서 알기쉽게 아이의 뼈나이와 성장속도를
                    설명해주셨어요.
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    아이한테도 어떤 걸 먹으면 좋은지 얘기해 주셔서 너무 좋았어요
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    절대로 공포 유발하지 않으시고 아이 진심으로 걱정해주십니다!
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">감사합니다</div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    말 한마디로도 큰 힘 주시는 선생님 항상 감사합니다
                  </div>
                </div>
              </div>
            </div>
            <div className="review_row">
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    원장님이 너무 진정성 있게 진료를 봐주시네요
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    의사선생님의 친절하고 성장에 대한 정확한 정보전달
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    동네에서 친절하기로 유명한 병원이에요.
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">너무 친절하십니다.</div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    좋은 말씀 많이 해주셨어요
                  </div>
                </div>
              </div>
              <div className="review_block">
                <div className={`review_img`}></div>
                <div className="review_text_box">
                  <div className="review_text title">
                    My kids have been seeing Dr.Hur
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="review_box">
            <MobileReviewSlick></MobileReviewSlick>
          </div>
          <div className="fifth_bottom_box">
            <div className="mobile_banner_text_box">
              <div className="banner_title">
                세계로 뻗어나가는 키움성장클리닉
              </div>
              <div className="banner_text">
                미국/캐나다/홍콩/ 싱가폴/ 말레이시아/ 베트남/몽골/중국/
                인도/호주/스위스/ 폴란드/네덜란드 /독일 세계에서 사랑받는
                키움성장클리닉입니다.
              </div>
            </div>
            <div className="bottom_banner"></div>
          </div>
        </div>
        <div className="m_sixth_area">
          <div className="third_title_box">
            <div className="title_box"></div>
            <div className="title_text">병원 둘러보기</div>
            <div className="title_sub">키움성장클리닉을 둘러봅니다.</div>
            <div className="title_btn" onClick={() => movePage("/clinic")}>
              모두 보기 {">"}
            </div>
          </div>
          <div className="sixth_img_box">
            <div className="img_row">
              <div className="img_box"></div>
              <div className="img_box second"></div>
            </div>
            <div className="img_row">
              <div className="img_box third"></div>
              <div className="img_box fourth"></div>
            </div>
            <div className="img_row">
              <div className="img_box fifth"></div>
              <div className="img_box sixth"></div>
            </div>
          </div>
          <div ref={mobileBottom}></div>
        </div>
        <div className="m_seventh_area">
          <div className="third_title_box">
            <div className="title_box"></div>
            <div className="title_text">찾아오시는 길</div>
            <div className="title_sub">
              키움성장클리닉을 찾아오시는 방법입니다.
            </div>
            <div className="title_btn" onClick={() => openMap()}>
              지도에서 보기 {">"}
            </div>
          </div>
          <div className="map_box">
            <MainMap></MainMap>
          </div>
          <div className="map_intro_box">
            <div className="map_contents_box">
              <div className="contents_title">
                서울특별시 서초구 반포대로 287
                <br /> 래미안퍼스티지 중심상가 3층
              </div>
              <div className="time_text_box">
                <div className="time_text">
                  평일 :
                  <div style={{ display: "inline-block", paddingLeft: 4 }}>
                    10 : 00 ~ 18 : 00
                  </div>
                </div>

                <div className="time_text">
                  토요일 :
                  <div style={{ display: "inline-block", paddingLeft: 4 }}>
                    09 : 00 ~ 13 : 00
                  </div>
                </div>
                <div className="time_text light">
                  (목요일 휴진, 점심시간 13-14시)
                </div>
              </div>
              <div className="tel_title">진료예약</div>
              <div className="tel_text">02-532-8575</div>
              <div className="sub_text">
                건물 3층에 위치 고속터미널역 출입구 6번 출구에서274m
                지하상가출구 1번출구(래미안퍼스티지아파트)에서 에스컬레이터로
                연결됩니다.
              </div>
              <div className="sub_text sub">지하 2,3층 주차장, 2시간무료</div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
